<template>
  <button @click="open" class="btn btn-sm btn-info mr-1 mb-1">
    <font-awesome-icon icon="arrow-right"/>&nbsp;{{ $t('title') }}
    <b-modal v-model="showForm" no-close-on-backdrop no-enforce-focus :title="$t('title')">
      <div class="alert alert-info" v-html="$t('guide')"></div>
      <form-select :label="$t('role')" :model="formModel" attribute="role" :errors="formErrors" :options="[
                    {value: null, text: $t('chooseRole')},
                    {value: 'am', text: 'Chăm sóc'},
                    {value: 'bd', text: 'Sales'},
                ]"></form-select>
      <admin-user-select :label="$t('fromUser')" :status="null" :model="formModel" attribute="fromUser" :errors="formErrors"></admin-user-select>
      <admin-user-select :label="$t('toUsers')" multiple :model="formModel" attribute="toUsers" :errors="formErrors"></admin-user-select>
      <template v-slot:modal-footer>
        <button class="btn btn-secondary float-right" @click="showForm = false">{{ $t('cancel') }}</button>
        <button class="btn btn-primary" @click="change()">
          {{ $t('change') }}
        </button>
      </template>
    </b-modal>
  </button>
</template>
<script>
  import AdminUserSelect from "../../components/AdminUserSelect";
  export default {
    components: {AdminUserSelect},
    data() {
      return {
        showForm: false,
        formModel: {
          fromAm: null,
          toAm: []
        },
        formErrors: []
      }
    },
    methods: {
      open() {
        this.formModel = {};
        this.showForm = true
      },
      change() {
        this.$swal({
          title: this.$t('changeConfirm'),
          icon: "warning",
          showCancelButton: true
        }).then((result) => {
          if (result.value) {
          let loader = this.$loading.show();
          this.$service({
              url: '/client/change-role',
              method: 'post',
              data: this.formModel
            }).then(response => {
              this.showForm = false;
              if (response.data) {
                this.$swal({
                    title: this.$t('success'),
                    text: this.$t('changeSuccess'),
                    icon: 'success'
                });
                this.$bus.$emit('loadClient');
              } else {
                this.$swal({
                    title: this.$t('error'),
                    text: this.$t('changeFailed'),
                    icon: 'error'
                });
              }
            }).catch(error => {
              if (error.response.data.message) {
                this.$swal({
                  text: error.response.data.message,
                  icon: 'error'
                });
                this.showForm = false;
              } else {
                this.formErrors = error.response.data;
              }
            }).finally(() => {
              loader.hide();
            });
          }
        })
      },
    },
    i18n: {
      messages: {
        en: {
          change: "Change",
          title: "Change Sales/Support",
          fromUser: "From user",
          toUsers: "To users",
          selectAM: "Select Support",
          changeConfirm: "Are you sure you want to make this change?",
          changeSuccess: "Change success",
          changeFailed: "Change failed",
          role: "Role",
          chooseRole: 'Choose role'
        },
        vi: {
          guide: "Khách hàng sẽ được chia đều cho các nhân viên đã chọn. Nếu không chọn, hệ thống sẽ thu hồi khách hàng",
          change: "Thay đổi",
          title: "Thay đổi Sales/Chăm sóc",
          fromUser: "Chuyển từ nhân viên",
          toUsers: "Tới các nhân viên",
          selectAM: "Chọn nhân viên chăm sóc",
          changeConfirm: "Bạn có chắc chắn muốn thực hiện thay đổi này?",
          changeSuccess: "Thay đổi thành công",
          changeFailed: "Thay đổi thất bại",
          role: "Vị trí",
          chooseRole: 'Chọn vị trí'
        }
      }
    }
  }
</script>